<!-- 患者姓名脱敏展示：默认脱敏，点击小眼睛后在患者档案弹窗层级内遮罩并于姓名下方展示全名 -->
<template>
  <span class="name-reveal">
    <span ref="nameRef" class="name-reveal-text">{{ maskedName }}</span>
    <!-- <eye-outlined /> -->
    <img class="name-reveal-eye" :src="EyeIcon" @click="handleShow" />
    <teleport :to="maskTarget">
      <div
        v-if="visible"
        class="name-reveal-mask"
        :class="{ 'name-reveal-mask--fixed': !maskInModal }"
        @click="close"
      >
        <div class="name-reveal-card" :style="cardStyle" @click.stop>
          <span class="card-label">患者姓名：</span>
          <span class="card-value">{{ name || '--' }}</span>
          <close-outlined class="card-close" @click="close" />
        </div>
      </div>
    </teleport>
  </span>
</template>

<script setup>
import { computed, ref, defineProps } from 'vue'
import { CloseOutlined } from '@ant-design/icons-vue'
import { maskName } from '@/utils'
import EyeIcon from '@/assets/img/patientPortrait/EyeIcon.png'
const props = defineProps({
  // 患者姓名原文（未脱敏）
  name: {
    type: String,
    default: ''
  }
})

const CARD_WIDTH = 215
const nameRef = ref(null)
const visible = ref(false)
const cardPos = ref({ top: 0, left: 0 })
// 遮罩挂在姓名所在弹窗的 .ant-modal-content 上，遮挡范围只到弹窗这一层而非全屏
const maskTarget = ref('body')
const maskInModal = ref(false)

const maskedName = computed(() => maskName(props.name))
const cardStyle = computed(() => ({
  position: maskInModal.value ? 'absolute' : 'fixed',
  top: `${cardPos.value.top}px`,
  left: `${cardPos.value.left}px`
}))

// 点击小眼睛：记录姓名位置，让姓名卡片定位在其下方
const handleShow = () => {
  const el = nameRef.value
  const modalContent = el ? el.closest('.ant-modal-content') : null
  if (el) {
    const rect = el.getBoundingClientRect()
    if (modalContent) {
      const modalRect = modalContent.getBoundingClientRect()
      // 容器必须为定位元素，否则遮罩会向上逃逸到更外层
      if (getComputedStyle(modalContent).position === 'static') {
        modalContent.style.position = 'relative'
      }
      maskInModal.value = true
      maskTarget.value = modalContent
      // 坐标换算到弹窗容器内，靠右时向左回收避免溢出弹窗
      cardPos.value = {
        top: rect.bottom - modalRect.top + 8,
        left: Math.max(8, Math.min(rect.left - modalRect.left, modalRect.width - CARD_WIDTH - 8))
      }
    } else {
      // 兜底：不在弹窗内时退回全屏遮罩 + 视口定位
      maskInModal.value = false
      maskTarget.value = 'body'
      cardPos.value = {
        top: rect.bottom + 8,
        left: Math.max(8, Math.min(rect.left, window.innerWidth - CARD_WIDTH - 8))
      }
    }
  }
  visible.value = true
}

const close = () => {
  visible.value = false
}
</script>

<style lang="scss" scoped>
.name-reveal {
  display: inline-flex;
  align-items: center;
  color: #031d4a;
  font-size: 18px;
  font-weight: 500;
  max-width: 100%;
  &-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &-eye {
    display: inline-block;
    margin-left: 8px;
    color: #014ea8;
    cursor: pointer;
    width: 16px;
    height: 12px;
  }
}
.name-reveal-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  // 跟随弹窗圆角裁剪，避免遮罩直角盖住弹窗圆角
  border-radius: inherit;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(17px);
  -webkit-backdrop-filter: blur(17px);

  &--fixed {
    position: fixed;
    z-index: 2050;
    border-radius: 0;
  }
}
.name-reveal-card {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 215px;
  height: 48px;
  padding: 0 16px;
  border-radius: 8px;
  background: url('~@/assets/img/patientPortrait/name_card_bg.png') no-repeat center / 100% 100%;
  // box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  padding-top: 4px;
  .card-label,
  .card-value {
    color: #3f5b7d;
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
    height: 48px;
    line-height: 48px;
  }
  .card-value {
    font-weight: 700;
  }
  .card-close {
    width: 18px;
    height: 18px;
    margin-left: auto;
    color: #3f5b7d;
    cursor: pointer;
  }
}
</style>
